import { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  debounce,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useLayoutExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { Transition } from "../../../../../../components";

export const CreateLayoutPadraoForm = () => {
  // State
  const {
    openCreateLayoutPadraoForm,
    createLayoutPadraoForm: { fields, errors, touched },
  } = useAppSelector((state) => state.layoutExtracao);
  // useState
  const [loading, setLoading] = useState<boolean>(true);
  // Hook
  const {
    setOpenCreateLayoutPadraoForm,
    createLayoutPadrao,
    setCreateLayoutPadraoFormNome,
  } = useLayoutExtracaoService();
  // Function
  const closeDialog = () => {
    setOpenCreateLayoutPadraoForm(false);
  };
  // useEffect
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <Dialog
          TransitionComponent={Transition}
          open={openCreateLayoutPadraoForm}
          onClose={closeDialog}
          maxWidth={false} // Remove a limitação padrão
          PaperProps={{
            sx: { width: "40vw", height: "40vh" }, // Define tamanho personalizado
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <Typography
                textAlign="center"
                sx={{ ml: 2, flex: 1 }}
                textTransform="uppercase"
                fontWeight="bold"
                variant="h6"
                component="div"
              >
                Clonar layout padrão
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent dividers sx={{ m: 2 }}>
            <TextField
              defaultValue={fields.Nome}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={debounce((e) => {
                setCreateLayoutPadraoFormNome(e.target.value);
              }, 300)}
              error={Boolean(
                touched && errors.find((item) => item.key === "Nome")
              )}
              helperText={errors.find((item) => item.key === "Nome")?.message}
              name="nome"
              fullWidth
              id="nome"
              label="Nome do Layout"
            />
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={6}>
                <Button
                  fullWidth
                  autoFocus
                  variant="outlined"
                  onClick={closeDialog}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    createLayoutPadrao();
                  }}
                >
                  Clonar
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
